import { Component, EventEmitter, input, OnInit, Output } from '@angular/core';
import { Help } from '../../features/help/abstract/help.abstract';
import { SLIDE_IN_UPWARDS } from "../../animations/animations";
import { CommonModule } from '@angular/common';
import { DontSanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';


@Component({
  selector: 'mono-common-help-popup',
  templateUrl: './help-popup.component.html',
  animations: [SLIDE_IN_UPWARDS],
  standalone: true,
  imports: [CommonModule, DontSanitizeHtmlPipe]
})
export class HelpPopupComponent extends Help implements OnInit {

  public open = input.required<boolean>();
  public shadow = input<boolean>(false);
  public pointer = input<boolean>(false);
  public enableAnimations = input<boolean>(false);

  @Output() removeHelpMessage: EventEmitter<any> = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  public preventFocusOnElementIfPointerPresent(event: Event) {
    if (this.pointer()) {
      event.preventDefault();
    }
  }

  public closeHelpPopup() {
    this.destroyWindowResize();
    this.removeHelpMessage.emit(null);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.closeHelpPopup();
  }

}
